import React from 'react';
import { OrdemDeServicoCompleta } from '../../types/ordemServico';
import { DollarSign, Wallet, PieChart } from 'lucide-react';
import { MaskedValue } from '../common/ProtectedField';

interface OsTotaisSectionProps {
  os: OrdemDeServicoCompleta;
}

export const OsTotaisSection: React.FC<OsTotaisSectionProps> = ({ os }) => {
  return (
    <div className="space-y-4 pt-4 border-t border-slate-200">
      <div className="flex items-center gap-2 border-b border-slate-100 pb-2">
        <PieChart className="w-4 h-4 text-red-600" />
        <h3 className="text-sm font-bold uppercase tracking-wider text-slate-700">Totais e Fechamento</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* Total O.S */}
        <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-xl">
          <span className="text-xs font-bold text-emerald-800 block uppercase flex items-center gap-1">
            <DollarSign className="w-4 h-4 text-emerald-600" /> Total O.S
          </span>
          <span className="text-xl font-black text-emerald-700 mt-1 block">
            <MaskedValue
              value={os.total_os}
              permission="view_order_prices"
              type="currency"
            />
          </span>
        </div>

        {/* Valor Total Repasses */}
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl">
          <span className="text-xs font-bold text-slate-500 block uppercase flex items-center gap-1">
            <Wallet className="w-4 h-4 text-slate-400" /> Valor Total Repasses
          </span>
          <span className="text-xl font-bold text-slate-900 mt-1 block">
            <MaskedValue
              value={os.valor_total_repasses}
              permission="view_order_repasse"
              type="currency"
            />
          </span>
        </div>

        {/* Valor Líquido */}
        <div className="p-4 bg-blue-50 border border-blue-200 rounded-xl">
          <span className="text-xs font-bold text-blue-800 block uppercase flex items-center gap-1">
            <DollarSign className="w-4 h-4 text-blue-600" /> Valor Líquido
          </span>
          <span className="text-xl font-black text-blue-700 mt-1 block">
            <MaskedValue
              value={os.valor_liquido}
              permission="view_order_margin"
              type="currency"
            />
          </span>
        </div>
      </div>
    </div>
  );
};
